import dynamic from 'next/dynamic';
import Heading from 'styles/typography/Heading';
import { ARTICLE_PAGE_TEST_IDS } from 'constants/testsIds/articlePage';
import type { AuthorBylineConfig } from 'interfaces/content/AuthorByline';
import type { Author } from 'interfaces/content/Authors';
import * as S from './AboutTheContributorsStyles';

const AuthorBio = dynamic(() => import('components/AuthorBio'), {
  ssr: false,
});

const AboutTheContributors = ({ authors, reviewedBy, isEducation = false, className = '' }: AuthorBylineConfig) => {
  let authorType;

  switch (true) {
    case isEducation:
      authorType = 'Contributors';
      break;
    case authors.length > 1:
      authorType = 'Authors';
      break;
    default:
      authorType = 'Author';
      break;
  }

  return (
    <S.AuthorsBioCards
      className={className}
      data-cy={ARTICLE_PAGE_TEST_IDS.AUTHORS_BIO_CARDS}
    >
      <Heading
        as='h4'
        $fontFamily='graphikCond'
        $size={{ default: 'level3' }}
        data-cy={ARTICLE_PAGE_TEST_IDS.AUTHORS_BIO_SECTION_TITLE}
      >
        About the {authorType}
      </Heading>
      {authors.map((author) => (
        <AuthorBio
          key={author.email}
          className='author-bio'
          author={author}
        />
      ))}
      {reviewedBy && (
        <AuthorBio
          key={reviewedBy.uri}
          className='author-bio'
          author={reviewedBy as Author}
        />
      )}
    </S.AuthorsBioCards>
  );
};

export default AboutTheContributors;
